import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import UnitPrice from './pricePartials/UnitPrice';
import PriceMessageType from 'apps/products/models/PriceMessageType';
import PriceType from 'apps/products/models/PriceType';
import OutOfStockInfo from './pricePartials/OutOfStockInfo';
import PriceTypical from './pricePartials/PriceTypical';
import MainPrice from './pricePartials/MainPrice';
import PricePromise from '../../../products/components/partials/PricePromise';
import PreviousPrice from './pricePartials/PreviousPrice';

export default class PriceContent extends PureComponent {
  static propTypes = {
    isValueDeliveredProduct: PropTypes.bool,
    price: PropTypes.shape({
      current: PropTypes.number,
      previous: PropTypes.number,
      lpp: PropTypes.bool,
      unit: PropTypes.object,
      messageType: PropTypes.oneOf(Object.keys(PriceMessageType)),
      type: PropTypes.oneOf(Object.keys(PriceType)).isRequired,
    }).isRequired,
    productLabels: PropTypes.array,
    zeroAfterPound: PropTypes.bool,
  };

  render() {
    const {
      isValueDeliveredProduct,
      price: { current, previous, lpp, unit, messageType, type },
      productLabels,
      zeroAfterPound,
    } = this.props;

    const unitPrice = unit
      ? <UnitPrice unitPrice={unit} />
      : null;

    const wrapperClasses = classNames(
      'price-group-wrapper', { 'price-group-wrapper__value-delivered': isValueDeliveredProduct }
    );

    return (
      <div className={wrapperClasses}>
        {OutOfStockInfo({ productLabels })}
        {PriceTypical({ messageType })}
        {MainPrice({
          currentPrice: current, isValueDeliveredProduct, lowPricePromise: lpp, type, zeroAfterPound,
        })}
        {isValueDeliveredProduct && <PricePromise className="opp-fop" />}
        {PreviousPrice({ previousPrice: previous, zeroAfterPound })}
        {unitPrice}
      </div>
    );
  }
}
